<template>
  <question
    prevTitle="Back"
    nextTitle="Next"
    prevEnabled
    :nextEnabled="turnoverAsNumber > 0"
    @prevClick="$router.go(-1)"
    @nextClick="next"
  >
    <div class="rounded shadow">
      <h3 v-if="$store.state.clientMode" class="pad inverted">Turnover for next 12 months (incl VAT)</h3>
      <h3 v-else class="pad inverted">Projected Factorable Turnover (Gross)</h3>
      <div class="inputPrefix toplined">
        <h3>£</h3>
        <input
          ref="turnoverInput"
          v-model.trim="turnover"
          inputmode="numeric" pattern="[0-9]*"
          @keydown.enter="$refs.turnoverInput.blur()"
        />
      </div>
    </div>
  </question>
</template>
<style lang="scss" scoped>
.pad {
  padding: 1em;
  box-sizing: border-box;
}
.inputPrefix {
  display: grid;
  grid-template-columns: auto 100%;
  padding-left: 1em;
  h3 {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  input {
    background-color: lightgrey;
    margin: 1em;
    border-radius: 7px;
  }
}
</style>
<script>
import question from "@/components/questionTemplate";

export default {
  props: {
    nextRoute: {
      type: String,
      default: "4"
    }
  },
  components: {
    question
  },
  beforeMount: function() {
    if (this.$store.state.formData.turnover) {
      this.turnover = this.$store.state.formData.turnover.toLocaleString(
        undefined,
        { maximumFractionDigits: 2 }
      );
    }
  },
  methods: {
    next: function() {
      if (this.turnoverAsNumber > 0) {
        this.$store.dispatch("setFormData", {
          turnover: this.turnoverAsNumber
        });
        this.$router.push(this.nextRoute);
      }
    }
  },
  data: function() {
    return {
      turnoverData: null
    };
  },
  computed: {
    turnoverAsNumber: function() {
      if (!this.turnoverData) {
        return null;
      }
      return parseInt(this.turnoverData.split(",").join(""));
    },
    turnover: {
      get: function() {
        return this.turnoverData || null;
      },
      set: function(newVal) {
        let num = parseInt(newVal.split(",").join(""));
        if (isNaN(num)) {
          this.turnoverData = null;
        } else {
          this.turnoverData = num.toLocaleString(undefined, {
            maximumFractionDigits: 2
          });
        }
      }
    }
  }
};
</script>